import { render, staticRenderFns } from "./IceCream.vue?vue&type=template&id=6a987708&"
import script from "./IceCream.vue?vue&type=script&lang=js&"
export * from "./IceCream.vue?vue&type=script&lang=js&"
import style0 from "./IceCream.vue?vue&type=style&index=0&id=6a987708&prod&lang=css&"
import style1 from "./IceCream.vue?vue&type=style&index=1&id=6a987708&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports